<template>
  <div class="tab_header terms">
    <div class="th_body">
      <div class="th_content" :class="{active : first}">
        <router-link to="/privacy">
          <p>개인정보 처리방침</p>
        </router-link>
      </div>
      <div class="th_content" :class="{active : second}">
        <router-link to="/terms">
          <p>회원약관</p>
        </router-link>
      </div>
      <div class="th_content" :class="{active : third}">
        <router-link to="/patient">
          <p>환자의 권리와 의무</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tab: {
      first: {
        default: false
      },
      second: {
        default: false
      },
      third: {
        default: false
      }
    }
  },
  data () {
    return {
      first: this.tab.first,
      second: this.tab.second,
      third: this.tab.third
    }
  }
}
</script>

<style lang="scss">
</style>
